import { combineReducers } from "redux";
import configReducer from "./configReducer";
import generalReducer from "./generalReducer";


const rootReducer = combineReducers({ configReducer, generalReducer });
export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js